import { type ReactNode, useRef } from 'react';
import { LoomIframe } from './required-video-iframe';
import { useLoomAdapter } from '@/hooks/use-required-video-loom';
import type { RequiredVideoState } from '@/hooks/use-required-video';

type Props = { videoId: string; state: RequiredVideoState };

export function RequiredVideoLoomPlayer({ videoId, state }: Props): ReactNode {
  const ref = useRef<HTMLIFrameElement>(null);
  useLoomAdapter({
    iframeRef: ref,
    onReady: state.onReady,
    onTime: state.onTime,
  });
  return <LoomIframe videoId={videoId} innerRef={ref} />;
}
